import classNames from 'classnames';
import { BEMBlock } from 'helpers/classnames';

import './Spinner.scss';

type SpinnerProps = {
    className?: string;
    isPadded?: boolean;
};

export function Spinner({
    className,
    isPadded = false,
}: SpinnerProps) {
    const [block, BEMElement] = BEMBlock('spinner', { padded: isPadded });

    return (
        <div className={classNames(block, className)}>
            <div className={BEMElement('ball')} />
            <div className={BEMElement('ball')} />
            <div className={BEMElement('ball')} />
            <div className={BEMElement('ball')} />
        </div>
    );
}
